<!-- <div class="bg-[#F9FAFE] py-3 px-2 fixed w-full top-[67px] z-10 dark:bg-black-500">
  <div class="custom-container flex items-center justify-between">
    <button class="flex items-center text-dark-500 font-bold uppercase dark:text-white" (click)="onNavigateToProfile()">
      <mat-icon class="material-symbols-outlined !h-[18px] !w-[18px] text-lg leading-[18px] dark:text-white">
        arrow_back_ios </mat-icon>Back
    </button>
  </div>
</div> -->
<div class="custom-container pt-16">
  @if (username) { @if(influencerDetail$ |async; as profile) {
  @if(profile.subscriptions.length > 0)
  {
  <div class="flex items-center flex-col">
    <h2 class="text-base font-bold mb-5">Purchase to unlock media</h2>
    <div class="grid grid-cols-2 w-full gap-4 mb-3">
      @for(subscription of profile.subscriptions; track subscription.id) {
      <div class="flex flex-col items-center bg-white rounded-lg w-full py-2 pb-4 cursor-pointer"
        (click)="onPurchaseSubscription(subscription)">
        <span>{{ subscription.type }}</span>
        <h2 class="text-2xl font-bold">{{ subscription.amount | currency : "GBP" : "symbol" : "1.2-2" }}</h2>
      </div>
      }
    </div>
    <div class="flex justify-around items-center flex-wrap gap-4 bg-white rounded-lg w-full py-3 px-2 sm:px-0">
      <span class="text-sm">Get a free raffle ticket with every purchase!</span>
      <button
        class="px-4 py-3 sm:px-6 sm:py-4 bg-purple-500 rounded-lg text-white sm:text-base font-bold whitespace-nowrap">
        Learn more
      </button>
    </div>

  </div>} @else {
  <div class="flex flex-col items-center justify-center h-full mb-5">
    <h4
      class="mt-4 mb-2 text-lg font-medium text-gray-500 dark:text-white text-center bg-white dark:bg-black-500 rounded-lg w-full p-4 pb-4">
      Influencer has no subscription</h4>
  </div>
  }
  } @if(posts$ | async; as Posts) { @if (Posts.length > 0) {
  <vota-media-list [posts$]="posts$"></vota-media-list>
  @if(nextPageNo){
  <div class="flex justify-center my-9">
    <button class="px-6 py-4 bg-purple-500 rounded-lg text-white text-base font-bold" (click)="loadMore()">
      Load more
    </button>
  </div>}
  }} } @if(isLoading ) {
  <div class="flex flex-1 items-center justify-center py-10 text-gray-500 min-h-[calc(100vh-67px)]">
    <mat-progress-spinner mode="indeterminate" diameter="40" color="primary">
    </mat-progress-spinner>
  </div>
  }@else if (userNotFound) {
  <div class="flex flex-col items-center justify-center min-h-[calc(100vh-67px)]">
    <div class="mb-5">{{ username }} does not exist</div>
    <button (click)="onBackToHome()" class="pink-btn-light !px-4">
      Back To Home
    </button>
  </div>
  }
</div>